<template>
  <div class="key_item clearfix">
    <div class="key_det clearfix">
      <p class="taopao_nums fl"><span>逃跑局数：</span>{{ offline }}</p>
      <p class="leisheng_nums fl"><span>累胜局数：</span>{{ gameNum }}/5</p>
    </div>
    <div class="clearfix key_state">
      <div v-for="(k, index) in keyList" :key="k.id" class="key_wrap fl">
        <div
          class="key"
          :class="keyStateClass(index)"
          :title="getTip(index)"
        >
        </div>
      </div>
      <a
        href="javascript:;"
        class="key_lq fl"
        :class="keyBtnClass"
        @click="getAward('18')"
      ></a>
    </div>
  </div>
</template>

<script setup> 
import {computed,reactive,defineProps} from 'vue';
import http from '@/utils/request';
import emitter from '@/utils/bus';
import {storeToRefs} from 'pinia';
import { useStore } from '../store/index';
const store = useStore();
let {btnState} = storeToRefs(store);

const props = defineProps({
  keyNum:Number,
  offline:Number,
  keyStr:String,
  drawKeyNum:Number,
  gameNum:Number
})


// watch(() =>props.keyStr, (newValue,oldValue) => {
//   console.log(newValue,oldValue)
//   thiskeyStr.value = newValue;
// }); 



const keyList= reactive([
        {id: 1, AwardName: "钥匙" },
        { id: 2, AwardName: "钥匙" },
        { id: 3, AwardName: "钥匙" },
        { id: 4, AwardName: "钥匙" },
        { id: 5, AwardName: "钥匙" },
        { id: 6, AwardName: "钥匙" },
      ]);

  const getKeyState = computed(()=>{
      //2是已领  //-1默认
      let str = props.keyStr.split(";"); //1,0,0,0,1,1
            var count = 0;
            for (let i = 0; i < 6; i++) {
              if (str[i]) {
                console.log(str[i]);
                if (str[i] == 1) {
                  count++;
                  if (props.drawKeyNum >= count) {
                    str[i] = 2;
                  }
                }
              }else{
                str[i] = -1;
              }
            }
            return str;
  })

 

  const keyBtnClass = computed(()=>{
    if (props.drawKeyNum < props.keyNum) {
        return "";
      }
      return "cant";
  })

  const getAward = function(id){
    if (props.drawKeyNum >= props.keyNum) {
        return;
      }
      if(!btnState.value) return;
        btnState.value = false;
        http.get("ActTask/DrawActTask", {
          params: {
            Id: id,
          },
        })
        .then((res) => {
          if (res.Code == 0) {
            btnState.value = true;
            emitter.emit("showaward", {msg:res.Obj, msgtype:1});
            try {
              window.parent.leftDH.isOnceArr[1] = true;
            } catch (e) {
              console.log(e);
            }
          } else {
            btnState.value = true;
            emitter.emit("showaward", {msg:res.Msg, msgtype:3});
          }
        });
  }

  const getTip = function(index){
    let keyState = getKeyState.value;
      if (keyState[index] == 2) {
        return "已领取的金钥匙";
      } else if (keyState[index] == 1) {
        return "当前可领取的金钥匙";
      } else if (keyState[index] == 0) {
        return "因逃跑失去了一把金钥匙获取上限";
      }
      return `再嬴${5 - props.gameNum}局即可获得一把金钥匙`;
  }

const keyStateClass = function(index){
  let keyState = getKeyState.value;
  if (keyState[index] == 2) {
        return "have";
      } else if (keyState[index] == 1) {
        return "can";
      } else if (keyState[index] == 0) {
        return "sui";
      }

      return "";
}

</script>

<style scoped>
.key_det {
  color: #fff;
  font-size: 14px;
  padding:3px 0 0 80px;
}
.key_det p {
  height: 25px;
  line-height: 25px;
  margin-right:15px;
}
.key_state{
  margin:5px 0 0 64px;
}
.key_wrap{
  padding-top:7px;
  width: 54px;
  height:54px;
  margin-right:17px;
}
.key_con .key {
  width: 54px;
  height: 54px;
  background: url("../assets/img/key3.png") center center no-repeat;
}
.key_con .key.sui {
  width: 54px;
  height: 54px;
  background: url("../assets/img/key2.png") center center no-repeat;
}
.key_con .key.have {
  width: 54px;
  height: 54px;
  background: url("../assets/img/key4.png") center center no-repeat;
}
.key_con .key.can {
  width: 54px;
  height: 54px;
  background: url("../assets/img/key1.png") center center no-repeat;
}
.key_con .key_lq {
  margin: 16px 0 0 18px;
  width: 96px;
  height: 32px;
  background: url("../assets/img/lq_btn.png") 0 0 no-repeat;
}
.key_con .key_lq:hover {
  background-position: 0 -32px;
}
.key_con .key_lq:active {
  background-position: 0 -64px;
}
.key_con .key_lq.cant {
  background-position: 0 -128px;
}
.key_con .key_lq.ylq {
  background-position: 0 -96px;
}
.taopao_nums span {
  color: #ebf3fa;
  font-size: 14px;
}
.leisheng_nums span {
  color: #ebf3fa;
  font-size: 14px;
}
</style>
